<div class="grid">
  <app-category-grid-header [title]="title()" />
  <div class="categories">
    <ng-content></ng-content>
  </div>
</div>